import React, { useLayoutEffect } from "react"
import { motion } from "framer-motion"
import { CombinedLandingRoutes } from "../Common/Routes"
import { Route, Switch } from 'react-router'
import { useDispatch } from "react-redux"
import { setPageTitle } from "../Store/Theme/actions"
import { withRouter } from "react-router-dom"
import TopBar from "../Pages/LandingPages/TopBar"
import Footer from "../Pages/LandingPages/Footer"

const getUrlElem = (url) => {
    let urlSplit = url.split('/')
    let route = CombinedLandingRoutes.filter(c => c.link !== null && c.link.split('/').length === urlSplit.length).find(c => c.link.split('/').every((i, j) => i[0] === ':' || i === urlSplit[j]))
    let urlParams = {}
    route?.link?.split('/').forEach((c, i) => {
        if (c[0] === ':') {
            urlParams[c.slice(1,)] = urlSplit[i]
        }
    })
    let { component: Elem = null, title = null, ItemIcon: icon = null, saveData = false, multiWindow = true } = route || {}
    return { Elem, title, icon, saveData, multiWindow, urlParams }
}


const HomeRoot = ({ history }) => {

    const dispatch = useDispatch()

    // set page title
    useLayoutEffect(() => {
        let path = getUrlElem(history.location.pathname)
        if (path) dispatch(setPageTitle(path.title))
    }, [history.location]) // eslint-disable-line

    return (
        <motion.div className="min-h-screen bg-pColor flex">
            <div className="w-full flex flex-col min-h-screen">
                <motion.div className="fixed w-full z-10 top-0">
                    <TopBar />
                </motion.div>
                <div className="text-left overflow-hidden min-h-screen pt-20 text-tpColor">
                    <Switch>
                        {CombinedLandingRoutes.map(c => (
                            <Route key={c.link} path={c.link} exact component={c.component} />
                        ))}
                    </Switch>
                </div>
                <motion.div className="bottom-0 inset-x-0">
                    <Footer />
                </motion.div>
            </div>
        </motion.div>
    )
}

export default withRouter(HomeRoot)